var cov_duc0q8or9 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/styles/index.js",
      hash = "5d3781462f11f046ae8ac6ddeb5857126f0e3157",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 27
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var sliderLess = {};
import genaration from '../../utils/classname';
export var sliderClass = (cov_duc0q8or9.s[0]++, genaration(sliderLess, 'slider'));